<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="TuxhornEthermP_4d00"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import TuxhornEthermP_4d00 from '@/device-products/TuxhornEthermP_4d00.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: TuxhornEthermP_4d00, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
